import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import HelpData from 'VisualStatic/HelpData';
import List from 'VisualStatic/components/List';
import SearchInput from 'VisualStatic/components/SearchInput';
import { CloseIcon, SearchIcon } from 'DesignSystem/Icons';

const DOCUMENT_NAME_TO_DOCUMENT_TITLE = {
  w2: 'W-2',
  form1099Misc: '1099-MISC',
  form1099Nec: '1099-NEC',
};

export default class HelpSideBar extends React.Component {
  // Filter against key words as well as title
  static filter(item, event) {
    const inKeywords = (item.keywords.filter(keyword => (
      keyword.toLowerCase().search(event.target.value.toLowerCase()) !== -1
    ))).length > 0;
    const inTitle = item.title.toLowerCase().search(
      event.target.value.toLowerCase()) !== -1;
    return inKeywords || inTitle;
  }

  static calculateSidebarHeightOffset() {
    const scrollOffset = window.scrollY;
    if (scrollOffset <= 60) {
      return 100.5 + (60 - scrollOffset);
    }
    return 100.5;
  }

  constructor(props) {
    super(props);
    this.state = {
      initialItems: HelpData[props.documentName],
      items: HelpData[props.documentName],
      sidebarHeightOffset: 100.5,
    };
    this.filterList = this.filterList.bind(this);
    this.hideSideBar = this.hideSideBar.bind(this);
    this.toggleScroll = this.toggleScroll.bind(this);
    this.setSidebarHeightOffset = this.setSidebarHeightOffset.bind(this);
  }

  componentDidMount() {
    if (this.props.isNarrow) {
      window.addEventListener('scroll', this.setSidebarHeightOffset);
      this.setSidebarHeightOffset();
    }
  }

  setSidebarHeightOffset() {
    this.setState({
      sidebarHeightOffset: HelpSideBar.calculateSidebarHeightOffset(),
    });
  }

  // Toggle scroll outside helpbar
  toggleScroll() {
    if (this.props.showSideBar) {
      document.querySelector('#resumebuilder').style.overflow = 'hidden';
    } else {
      document.querySelector('#resumebuilder').style.overflow = 'auto';
    }
  }

  filterList(event) {
    let updatedList = this.state.initialItems;
    updatedList = updatedList.filter(item => (
      HelpSideBar.filter(item, event)
    ));
    this.setState({
      items: updatedList,
    });
  }

  hideSideBar() {
    this.props.toggleHelpSideBar();
  }

  render() {
    const {
      documentName,
      isNarrow,
      showSideBar,
      updateBackgroundImage,
    } = this.props;

    this.toggleScroll();
    const sidebarStateClass = classNames(
      'help-side-bar',
      {
        'help-side-bar-show': showSideBar,
        'help-side-bar-hide': !showSideBar,
        'narrow-help-side-bar': isNarrow,
      },
    );

    const heightOffsetStyle = {
      height: `calc(100% - ${this.state.sidebarHeightOffset}px)`,
    };
    const sidebarStyle = isNarrow && showSideBar ? heightOffsetStyle : {};
    return (
      <div
        className={sidebarStateClass}
        style={sidebarStyle}
      >
        <CloseIcon
          className="help-side-bar-close-icon"
          onClick={this.hideSideBar}
        />
        <div className="help-side-bar-input-wrapper">
          <div className="help-document-title">
            <h3>{DOCUMENT_NAME_TO_DOCUMENT_TITLE[documentName]} - Help</h3>
          </div>
          <SearchInput
            filterList={this.filterList}
            placeholder={isNarrow ? 'Search box number or keyword' : 'Search for a box number or keyword'}
          >
            {isNarrow &&
              <SearchIcon className="help-side-bar-input-icon" />
            }
          </SearchInput>
        </div>
        <div className="help-side-bar-list-wrapper">
          <List
            documentName={documentName}
            items={this.state.items}
            updateBackgroundImage={updateBackgroundImage}
          />
        </div>
      </div>
    );
  }
}

HelpSideBar.defaultProps = {
  isNarrow: false,
  showSideBar: false,
  toggleHelpSideBar: null,
  updateBackgroundImage: null,
};

HelpSideBar.propTypes = {
  documentName: PropTypes.string.isRequired,
  isNarrow: PropTypes.bool,
  showSideBar: PropTypes.bool,
  toggleHelpSideBar: PropTypes.func,
  updateBackgroundImage: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src-react/VisualStatic/HelpSideBar/index.jsx